import styled from "styled-components";

export const ContentNotFound = styled.h3`
  margin-top: 20px;
`;
